import { createStore } from "vuex";
import { advisor_types_api, advisors_api, advisor_api, consumer_direct } from "../../../config/api";
import { filterAdvisors } from "../functions/filters";
import axios from "axios";

export default createStore({
    state: {
        advisors: [],
        distance: null,
        filters: {
            hours: null,
            type: null
        },
        isInitializing: true,
        isLoading: true,
        isSpecificAdvisor: false,
        isDirectConsumer: false,
        selectedAdvisor: null,
        typeFilterOptions: [],
        userSearchLocation: {},
        newConsumerDirect: [],
        userSearchName: null,
        currentPage: 1
    },
    mutations: {
        SET_ADVISORS(state, advisors) {
            state.advisors = advisors;
        },
        SET_FILTERS(state, payload) {
            state.filters = payload;
        },
        SET_INITIALIZING(state, payload) {
            state.isInitializing = payload;
        },
        SET_IS_SPECIFIC_ADVISOR(state, payload) {
            state.isSpecificAdvisor = payload;
        },
        SET_IS_DIRECT_CONSUMER(state, payload) {
            state.isDirectConsumer = payload;
        },
        SET_LOADING(state, isLoading) {
            state.isLoading = isLoading;
        },
        SET_SELECTED_ADVISOR(state, advisor) {
            state.selectedAdvisor = advisor;
        },
        SET_TYPE_FILTER_OPTIONS(state, options) {
            state.typeFilterOptions = options;
        },
        SET_USER_DISTANCE(state, distance) {
            state.distance = distance;
        },
        SET_USER_SEARCH_LOCATION(state, location) {
            state.userSearchLocation = location;
        },
        SET_USER_SEARCH_NAME(state, name) {
            state.userSearchName = name;
        },
        SET_USER_TYPE(state, payload) {
            state.filters.type = payload;
        },
        SET_NEW_ADVISORS(state, advisors) {
            state.newConsumerDirect = advisors;
        },
        INCREMENT_CURRENT_PAGE(state) {
            state.currentPage++
        },
        RESET_CURRENT_PAGE(state) {
            state.currentPage = 1;
        }
    },
    getters: {
        filteredAdvisors(state) {
            return filterAdvisors(state.advisors, state.filters);
        },
        isInitializing(state) {
            return state.isInitializing;
        },
        isLoading(state) {
            return state.isLoading;
        },
        isSpecificAdvisor(state) {
            return state.isSpecificAdvisor;
        },
        isDirectConsumer(state) {
            return state.isDirectConsumer;
        },
        selectedAdvisor(state) {
            return state.selectedAdvisor;
        },
        typeFilterOptions(state) {
            return state.typeFilterOptions;
        },
        userDistance(state) {
            return state.distance;
        },
        userHours(state) {
            return state.filters.hours;
        },
        userSearchLocation(state) {
            return state.userSearchLocation;
        },
        userSearchName(state) {
            return state.userSearchName;
        },
        userType(state) {
            return state.filters.type;
        },
        newConsumerDirect(state) {
            return filterAdvisors(state.newConsumerDirect, state.filters);
        },
        currentPage(state) {
            return state.currentPage
        }
    },
    actions: {
        clearSearch({ commit }) {
            commit("SET_ADVISORS", []);
            commit("SET_INITIALIZING", false);
            commit("SET_LOADING", false);
            commit("SET_FILTERS", {
                hours: null,
                type: null
            });
            commit("SET_USER_SEARCH_LOCATION", {});
            commit("SET_NEW_ADVISORS", []);
            commit("SET_USER_SEARCH_NAME", null);
        },
        geolocateUser: async ({ commit }) => {
            if (navigator.geolocation) {
                commit("SET_LOADING", true);
                await navigator.geolocation.getCurrentPosition(
                    position => {
                        let payload = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };

                        commit("SET_USER_SEARCH_LOCATION", payload);
                    },
                    err => {
                        console.log(err);
                    }
                );
            }
        },
        getTypeFilterOptions: async ({ commit }) => {
            try {
                let { data } = await axios.get(
                    advisor_types_api.URI,
                    {
                        auth: advisor_api.auth
                    }
                );
                commit("SET_TYPE_FILTER_OPTIONS", data);
            } catch (e) {
                console.log(e);
            }
        },
        getSpecificAdvisor: async ({ commit, dispatch }, payload) => {
            commit("SET_LOADING", true);
            if (payload && payload.id) {
                try {
                    let { data } = await axios.get(
                        advisor_api.URI,
                        {
                            params: payload,
                            auth: advisor_api.auth
                        }
                    );
                    commit("SET_SELECTED_ADVISOR", data);
                    commit("SET_IS_SPECIFIC_ADVISOR", true);
                    commit("SET_LOADING", false);
                    commit("SET_INITIALIZING", false);
                } catch (e) {
                    console.log(e);
                }
            } else {
                dispatch("updateAdvisors", {
                    radius: all
                });
            }
        },
        updateAdvisors: async ({ commit }, payload) => {
            commit("SET_LOADING", true);
            commit("SET_IS_DIRECT_CONSUMER", false);
            try {
                let { data } = await axios.get(
                    advisors_api.URI,
                    {
                        params: payload,
                        auth: advisors_api.auth
                    }
                );
                commit("SET_ADVISORS", data.advisors);
                commit("SET_LOADING", false);
                commit("SET_INITIALIZING", false);
            } catch (e) {
                console.log(e);
            }
        },
        updateAdvisorsWithConsumer: async ({ commit }) => {
            commit("SET_LOADING", true);
            commit("SET_IS_DIRECT_CONSUMER", true);
            try {
                let { data } = await axios.get(
                    consumer_direct.URI,
                    {
                        auth: consumer_direct.auth
                    }
                );
                //console.log(data)
                commit("SET_NEW_ADVISORS", data.advisors);
                commit("SET_LOADING", false);
                commit("SET_INITIALIZING", false);
            } catch (e) {
                console.log(e);
            }
        },
        updateDistance({ commit }, payload) {
            commit("SET_USER_DISTANCE", payload);
        },
        updateFilters({ commit }, payload) {
            commit("SET_FILTERS", payload);
        },
        updateIsInitializing({ commit }, payload) {
            commit("SET_INITIALIZING", payload);
        },
        updateSelectedAdvisor({ commit }, payload) {
            commit("SET_SELECTED_ADVISOR", payload);
        },
        updateDirectConsumer({ commit }, payload) {
            commit("SET_IS_DIRECT_CONSUMER", payload);
        },
        updateNewConsumerDirect({ commit }, payload) {
            commit("SET_NEW_ADVISORS", payload);
        },
        updateUserSearchLocation({ commit }, payload) {
            commit("SET_USER_SEARCH_LOCATION", payload);
        },
        updateUserSearchName({ commit, dispatch }, payload) {
            commit("SET_USER_SEARCH_NAME", payload.name);
            dispatch("updateAdvisors", payload);
        },
        updateUserType({ commit }, payload) {
            commit("SET_USER_TYPE", payload);
        },
        incrementCurrentPage({ commit }) {
            commit("INCREMENT_CURRENT_PAGE");
        },
        resetCurrentPage({ commit }) {
            commit("RESET_CURRENT_PAGE");
        }
    }
});
